import { render, staticRenderFns } from "./ServiceRequestIndex.vue?vue&type=template&id=2764b0a4&scoped=true&"
import script from "./ServiceRequestIndex.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestIndex.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestIndex.vue?vue&type=style&index=0&id=2764b0a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2764b0a4",
  null
  
)

export default component.exports